/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { enableProdMode } from '@angular/core';

import { environment } from '@env/environment';
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {AppModule} from "@app/app.module";

if (environment.production) {
	enableProdMode();
}

// bootstrapApplication(AppComponent, appConfig)
// 	.catch(err => console.log(err));

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));


if ('serviceWorker' in navigator && environment.production) {
	// Register a service worker hosted at the root of the
	// site using a more restrictive scope.
	navigator.serviceWorker.register('./ngsw-worker.js').then(function(registration) {
		console.log('Service worker registration succeeded: ', registration);
	}).catch(function(error) {
		console.log('Service worker registration failed: ', error);
	});
} else {
	console.log('Service workers are not supported.');
}
